export default __webpack_public_path__ + "static/media/PlayButton.e7fe72d4.png";